export const setToken = (state, { value }) => {
  localStorage.setItem('token', value);
  return state.setIn(['token'], value);
};
